// Client-side timeout for requests that are polled/retried, so a hanging backend fails
// fast instead of leaving a request in flight for minutes.
export const REQUEST_TIMEOUT_MS = 15000;
